export default "__VITE_ASSET__Dxbunuyk__"